import {MuWidget} from "mu-widget/lib/MuWidget";
import {TreeView} from "./components/TreeView";

export class Sandbox extends MuWidget {
	beforeIndex() {
		this.muAppendContent(`
		<ul mu="treeList:TreeView">
			<li mu=":.@item">
				<span mu-bind="name"></span>
				<ul mu-id="children"></ul>
			</li>
		</ul>
		<div mu="treeLinear:TreeView">
			<div mu=':.@item#plunge|append("em"):style.marginLeft'>
				<span mu-bind="name"></span>
			</div>		
		</div>
		`);
	}

	afterIndex() {
		const data1 = [
			{
				name: "Foo",
				children: [
					{name: "Bar"},
					{name: "Baz"},
				]
			}
		];
		const data2 = [
			{name: "foo", id:1, parentId: null },
			{name: "bar", id:2, parentId: 1 },
			{name: "baz", id:3, parentId: 2 },
			{name: "eee", id:4, parentId: 456 },
		];

		(this.muNamedWidget.treeList as unknown as TreeView).render(data1, {
			srcStructFormat: "childField",
			outStructType: "plunge",
		});
		(this.muNamedWidget.treeLinear as unknown as TreeView).render(data1, {
			srcStructFormat: "childField",
			outStructType: "indent",
		});
		(this.muNamedWidget.treeList as unknown as TreeView).render(data2, {
			srcStructFormat: "parentField",
			outStructType: "plunge",
		});
		(this.muNamedWidget.treeLinear as unknown as TreeView).render(data2, {
			srcStructFormat: "parentField",
			outStructType: "indent",
		});
	}
}